import React, { useState } from 'react';
import LocationPage from './LocationPage/LocationPage';
import MainPage from './components/MainPage/MainPage';
import NavBar from './components/navBar/NavBar';
import useGeolocation from 'react-hook-geolocation'

function App() {
  const geolocation = useGeolocation()
  

  const [cond,setCond]=useState('')

    const readyElement =(geolocation)=>{
    return (<div><NavBar/>
    <MainPage data={geolocation}/></div>)} 
    
    
    const NonReadyElemnt = <div><NavBar cond={cond} setCond={setCond} /><LocationPage cond={cond} setCond={setCond}/></div>

  return  (
    <>
    {geolocation.latitude && geolocation.latitude ? readyElement(geolocation):NonReadyElemnt}
    </>
    
  ) 
}

export default App;
